<template>
  <div style="min-height:72vh;padding:10px">
    <Form :model="searchData" inline :label-width="100">
      <FormItem label="所属级别">
        <Select
          @on-change="getData(1)"
          v-model="searchData.grade_id"
          clearable
          style="width: 9vw"
        >
          <Option v-for="(i, n) in gradeList" :value="i.id" :key="n">{{
            i.name
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="所属科目">
        <Select
          @on-change="getData(1)"
          v-model="searchData.subject_id"
          clearable
          style="width: 9vw"
        >
          <Option v-for="(i, n) in subjectList" :value="i.id" :key="n">{{
            i.name
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="所属课程">
        <Select
          @on-change="getData(1)"
          v-model="searchData.course_id"
          clearable
          style="width: 9vw"
        >
          <Option v-for="(i, n) in curseList" :value="i.id" :key="n">{{
            i.name
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="章节名称">
        <Input
          v-model="searchData.name"
          @on-change="getData(1)"
          style="width: 9vw"
          clearable
        />
      </FormItem>
    </Form>
    <div style="text-align:right;margin-bottom:10px">
      <Button size="small" @click="$router.go(-1)">返回</Button>
    </div>
    <Table
      :columns="tableColumns"
      :data="tableData.data"
      :loading="tableLoading"
      border
      style="margin:10px 0;"
    >
      <template slot-scope="{ row }" slot="index">
        {{ (tableData.current_page - 1) * 10 + row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="is_buy">
        {{ row.is_buy == 1 ? "是" : "否" }}
      </template>
      <template slot-scope="{ row }" slot="is_free">
        {{ row.is_free == 1 ? "是" : "否" }}
      </template>
      <template slot-scope="{ row }" slot="is_display">
        {{ row.is_display == 2 ? "是" : "否" }}
      </template>
      <template slot-scope="{ row }" slot="total_count">
        <span>{{ row.is_buy == 1 ? row.finish_count : 0 }}/</span
        >{{ row.total_count }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button type="warning" size="small" @click="pingjia(row)">评分</Button>
        <Button
          v-if="row.is_buy == 1"
          type="info"
          size="small"
          @click="
            $router.push(
              '/examinationBank/paperLibraryExe?id=' +
                row.id +
                '&name=' +
                row.name
            )
          "
          >试卷练习</Button
        >
        <Button
          v-if="row.is_buy == 0 && row.is_free == 1"
          type="primary"
          size="small"
          @click="addCourse(row)"
          >添加</Button
        >
        <Button
          v-if="row.is_buy == 0 && row.is_free == 2"
          type="primary"
          size="small"
          @click="addCourse(row)"
          >购买</Button
        >
      </template>
    </Table>
    <Modal
      v-model="pingjiashow"
      title="评分"
      @on-cancel="pingjiashow = false"
      @on-ok="pingjiaOK"
    >
      <Rate v-model="pjobj.score" :count="10"></Rate>
    </Modal>
    <Page
      style="text-align:right"
      :total="tableData.total"
      :page-size="tableData.per_page"
      :current="tableData.current_page"
      show-total
      @on-change="getData"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import indexPage from "../../mixins/indexPage";
export default {
  computed: {
    ...mapState({
      gradeList(state) {
        return state.global.gradeList;
      },
      subjectList(state) {
        return state.global.subjectList;
      },
      curseList(state) {
        return state.global.curseList;
      }
    })
  },
  data() {
    return {
      searchData: {
        grade_id: "",
        subject_id: ""
      },
      pingjiashow: false,
      pjobj: {
        score: 0
      },
      tableColumns: [
        {
          title: "序号",
          slot: "index",
          align: "center",
          fixed: "left",
          width: 80
        },
        { title: "试卷库名称", key: "name", align: "center", minWidth: 200 },
        {
          title: "试卷数量",
          key: "total_count",
          align: "center",
          minWidth: 120
        },
        // {
        //   title: "所属课程",
        //   key: "course_name",
        //   align: "center",
        //   minWidth: 120
        // },
        /*
          {
            title: "所属级别",
            key: "grade_name",
            align: "center",
          },
          {
            title: "所属科目",
            key: "subject_name",
            align: "center",
          },
          */
        {
          title: "原价",
          key: "original_total_price",
          align: "center",
          minWidth: 120
        },
        {
          title: "现价",
          key: "current_total_price",
          align: "center",
          minWidth: 120
        },
        { title: "评分", key: "average_score", align: "center", minWidth: 120 },
        // { title: "是否购买", slot: "is_buy", align: "center"},
        // { title: "是否免费", slot: "is_free", align: "center"},
        // { title: "是否启用", slot: "is_display", align: "center"},

        { title: "操作", slot: "action", align: "center", width: 180 },
        { title: "备注", key: "remark", align: "center", width: 120 }
      ],
      indexUrl: "/app/source_exam_paper_storage/index"
    };
  },
  mounted() {
    this.searchData.section_id = this.$route.query.id;
  },
  activated() {
    // 初始化筛选列表
    this.$store.dispatch("global/getAllSelect");
    this.searchData.section_id = this.$route.query.id;
    setTimeout(() => {
      this.getData(1);
    }, 500);
  },
  mixins: [indexPage],

  methods: {
    pingjia(row) {
      this.pingjiashow = true;
      this.pjobj.storage_id = row.id;
      this.pjobj.type = 2;
      this.pjobj.score = row.self_score;
    },
    pingjiaOK() {
      this.$axios.post("/app/comment/addData", this.pjobj).then(res => {
        if (res.code == 1) {
          this.getData(this.tableData.current_page);
          this.$Message.success("评价成功");
          this.pingjiashow = false;
        } else {
          this.$Message.info(res.msg);
        }
      });
    },
    // 购买课程
    addCourse(row) {
      if (row.is_bug == 0) {
        this.$axios
          .post("/app/source_exam_paper_storage/buy", { id: row.id })
          .then(res => {
            if (res.code == 1) {
              this.$Message.success("添加成功");
              this.getData(this.tableData.current_page);
            } else {
              this.$Message.error(res.msg);
            }
          });
        return false;
      }
      this.$Modal.confirm({
        content: "此试卷库需要购买，是否购买？",
        onOk: () => {
          this.$axios
            .post("/app/source_exam_paper_storage/buy", { id: row.id })
            .then(res => {
              if (res.code == 1) {
                this.$Message.success("购买成功");
                this.getData(this.tableData.current_page);
              } else {
                this.$Message.error(res.msg);
              }
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.group-name:nth-child(n + 2)::before {
  content: " / ";
}
</style>
